import {paqueteParaZona} from './aplicacionPaquetes';
import { importeCentavos, consumoDelPaquete, grupoEconomicoEntrada } from './dinero';
export const MAX_ENTRADAS_RESERVA = 400; // reserva + log + entradas < 500 escrituras
export const MAX_EXTRAS_RESERVA = 5;
const fail = (message) => { throw new Error(message); };
export function cantidadPaquete(p) {
  const n = p?.cantidadEntradas;
  if (!Number.isSafeInteger(n) || n < 0 || n > MAX_ENTRADAS_RESERVA) fail('El paquete requiere cantidadEntradas entera explícita (0–400).');
  return n;
}
export function reservaDocId({ empresaId, eventoId, zonaId }) {
  const parts = [empresaId, eventoId, zonaId];
  if (parts.some((p) => typeof p !== 'string' || !/^[A-Za-z0-9_-]{1,120}$/.test(p) || p.includes('__'))) fail('Identificadores de empresa/evento/zona no compatibles con nuevas reservas.');
  return parts.join('__');
}
export const entradaReservaId = (id, indice) => `${id}__entrada__${indice}`;
export function prepararPrepago(evento, lista, paquete, carrito = {}, tipoZona, ubicacion) {
  const listaId = evento.listaReservaId;
  if (!listaId || lista.id !== listaId || lista.activo === false || paquete.activo === false || !lista.paquetes?.includes(paquete.id)) fail('Lista o paquete no disponible.');
  if (!paqueteParaZona(paquete,tipoZona,ubicacion?.zonaId,ubicacion)) fail('El paquete no corresponde a esta zona o versión de recinto.');
  const cantidadEntradas = cantidadPaquete(paquete);
  const montoCentavos = importeCentavos(paquete.precioCentavos);
  const consumoCentavos = consumoDelPaquete(paquete);
  const extras = Object.entries(carrito).filter(([, qty]) => qty !== 0).map(([id, qty]) => {
    const comboIndice = (evento.combos || []).findIndex((c) => c.id === id);
    const c = evento.combos?.[comboIndice];
    if (!c || !Number.isSafeInteger(qty) || qty <= 0 || !Number.isSafeInteger(c.cantidadEntradas) || c.cantidadEntradas < 1) fail('Extra o cantidad inválida.');
    const precioCentavos = importeCentavos(c.precioCentavos);
    return { productoId: id, comboIndice, nombre: c.nombre || id, qty, entradasPorUnidad: c.cantidadEntradas,
      precioCentavos, cantidadEntradas: qty * c.cantidadEntradas, subtotalCentavos: qty * precioCentavos };
  });
  if (extras.length > MAX_EXTRAS_RESERVA) fail('Máximo cinco tipos de extra por reserva.');
  let indiceInicio = cantidadEntradas;
  extras.forEach((extra) => { extra.indiceInicio = indiceInicio; indiceInicio += extra.cantidadEntradas; });
  const cantidadEntradasExtras = extras.reduce((s, x) => s + x.qty * x.entradasPorUnidad, 0);
  const cantidadEntradasEmitidas = cantidadEntradas + cantidadEntradasExtras;
  if (cantidadEntradasEmitidas > MAX_ENTRADAS_RESERVA) fail('La emisión supera el límite de 400 entradas; no se ha escrito nada.');
  const montoExtrasCentavos = extras.reduce((s, x) => s + x.subtotalCentavos, 0);
  const montoTotalCentavos = montoCentavos + montoExtrasCentavos;
  if (!Number.isSafeInteger(montoTotalCentavos) || montoTotalCentavos > 100000000) fail('Importe total fuera del límite.');
  return { listaReservaId: listaId, paqueteId: paquete.id, paqueteNombre: paquete.nombre,
    cantidadEntradas, cantidadEntradasExtras, cantidadEntradasEmitidas, extras,
    paqueteIncluye: (Array.isArray(paquete.incluye) ? paquete.incluye : typeof paquete.incluye === 'string' ? paquete.incluye.split(/\r?\n|,/) : []).filter(v => typeof v === 'string' && v.trim()).map(v => v.trim()),
    montoCentavos, montoExtrasCentavos, montoTotalCentavos,
    ...(consumoCentavos === null ? {} : { consumoCentavos }),
    emisionVersion: 1, contratoReserva: 2 };
}
export function prepararEntradas(reserva, id, emitidoPorUid) {
  const result = [];
  const base = { eventoId: reserva.eventoId, eventoNombre: reserva.eventoNombre, empresaId: reserva.empresaId,
    empresaNombre: reserva.empresaNombre, reservaId: id, paqueteId: reserva.paqueteId, paqueteNombre: reserva.paqueteNombre,
    atribuidoAUid: reserva.atribuidoAUid, atribuidoANombre: reserva.atribuidoANombre, atribuidoARol: reserva.atribuidoARol,
    comprador: reserva.nombreCliente, creadoPorUid: reserva.creadoPorUid,
    creadoPorNombre: reserva.creadoPorNombre || '', creadoPorRol: reserva.creadoPorRol || '', emitidoPorUid, origen: 'reserva', emisionVersion: 1, estado: 'no_usada' };
  for (let i = 0; i < reserva.cantidadEntradas; i++) result.push({ ...base, tipoEntrada: 'paquete', extraIndice: -1 });
  reserva.extras.forEach((extra, extraIndice) => {
    for (let i = 0; i < extra.qty * extra.entradasPorUnidad; i++) result.push({ ...base, tipoEntrada: 'extra', extraIndice, comboId: extra.productoId });
  });
  return result.map((d, indiceEntrada) => ({ ...d, ...(grupoEconomicoEntrada(d, reserva) || {}), indiceEntrada, id: entradaReservaId(id, indiceEntrada) }));
}
export function verificarEmision(reserva, items) {
  if (reserva.emisionVersion === 2) return verificarEmisionV2(reserva, items);
  if (reserva.emisionVersion !== 1 || !Number.isSafeInteger(reserva.cantidadEntradasEmitidas)) fail('EMISIÓN INCONSISTENTE: histórico sin cantidad verificable. No se emitirán entradas automáticamente.');
  if (reserva.cantidadEntradasEmitidas < 0 || reserva.cantidadEntradasEmitidas > MAX_ENTRADAS_RESERVA ||
      !Number.isSafeInteger(reserva.cantidadEntradas) || reserva.cantidadEntradas < 0 || !Array.isArray(reserva.extras) ||
      reserva.extras.some((x) => !Number.isSafeInteger(x.cantidadEntradas) || x.cantidadEntradas < 1 || x.cantidadEntradas !== x.qty * x.entradasPorUnidad) ||
      reserva.cantidadEntradas + reserva.extras.reduce((n, x) => n + x.cantidadEntradas, 0) !== reserva.cantidadEntradasEmitidas) {
    fail('EMISIÓN INCONSISTENTE: cantidades del snapshot inválidas.');
  }
  const esperadas = prepararEntradas(reserva, reserva.id, reserva.prepagoPorUid);
  const campos = ['eventoId','empresaId','reservaId','paqueteId','atribuidoAUid','atribuidoANombre','atribuidoARol','creadoPorUid','comprador','tipoEntrada','extraIndice','comboId'];
  const ids = new Set(items.map((x) => x.id));
  if (items.length !== reserva.cantidadEntradasEmitidas || ids.size !== items.length || items.some((x) =>
    !esperadas[x.indiceEntrada] || x.id !== entradaReservaId(reserva.id, x.indiceEntrada) || campos.some((campo) => x[campo] !== esperadas[x.indiceEntrada][campo]) ||
    ['creadoPorNombre','creadoPorRol'].some((campo) => x[campo] && x[campo] !== esperadas[x.indiceEntrada][campo]) ||
    ['precioComboCentavos','entradasEnCombo'].some((campo) => x[campo] !== undefined && x[campo] !== esperadas[x.indiceEntrada][campo])) ||
    esperadas.some((x) => !ids.has(x.id))) {
    fail('EMISIÓN INCONSISTENTE: cantidad o relaciones incorrectas. Requiere revisión; no se completará automáticamente.');
  }
  return items.sort((a, b) => a.indiceEntrada - b.indiceEntrada);
}

// Rangos append-only: una ampliación nunca desplaza los índices de QR existentes.
export function gruposDeEntradas(items) {
  const grupos = [];
  const keys = ['tipoEntrada','extraIndice','comboId','paqueteId','paqueteNombre','precioComboCentavos','entradasEnCombo','emitidoPorUid','compraId'];
  for (const t of [...items].sort((a,b)=>a.indiceEntrada-b.indiceEntrada)) {
    const datos = Object.fromEntries(keys.filter(k=>t[k] !== undefined).map(k=>[k,t[k]]));
    const ultimo = grupos[grupos.length-1];
    if (ultimo && ultimo.inicio+ultimo.cantidad===t.indiceEntrada && JSON.stringify(ultimo.datos)===JSON.stringify(datos)) ultimo.cantidad++;
    else grupos.push({inicio:t.indiceEntrada,cantidad:1,datos});
  }
  return grupos;
}
export function verificarEmisionV2(reserva, items) {
  const failV = () => fail('EMISIÓN INCONSISTENTE: rangos o relaciones incorrectas.');
  if (!Array.isArray(reserva.gruposEmision) || !Number.isSafeInteger(reserva.cantidadEntradasEmitidas) || reserva.cantidadEntradasEmitidas<0 || reserva.cantidadEntradasEmitidas>400 || items.length!==reserva.cantidadEntradasEmitidas) failV();
  let indice = 0; const porId = new Map(items.map(t=>[t.id,t]));
  if (porId.size !== items.length) failV();
  for (const grupo of reserva.gruposEmision) {
    if (grupo.inicio!==indice || !Number.isSafeInteger(grupo.cantidad) || grupo.cantidad<1 || !grupo.datos) failV();
    for(let n=0;n<grupo.cantidad;n++,indice++) {
      const t=porId.get(entradaReservaId(reserva.id,indice));
      if (!t || t.indiceEntrada!==indice || t.reservaId!==reserva.id || t.eventoId!==reserva.eventoId || t.empresaId!==reserva.empresaId || t.comprador!==reserva.nombreCliente ||
          ['atribuidoAUid','atribuidoANombre','atribuidoARol','creadoPorUid'].some(k=>t[k]!==reserva[k]) ||
          Object.keys(grupo.datos).some(k=>t[k]!==grupo.datos[k])) failV();
    }
  }
  if(indice!==items.length) failV();
  return items.sort((a,b)=>a.indiceEntrada-b.indiceEntrada);
}
